module.exports = __webpack_public_path__ + "static/AR-170919740-190ebffba9391cbfc815ae4cb6bd3aa7.jpg";